import React from 'react';
import { Navigate } from 'react-router-dom';
import MonkLayout from '../Layout/MonkLayout/MonkLayout';

const isMonk = () => {
  const role = JSON.parse(localStorage.getItem('role') || 'null');
  return role === 'Monk';
};

const ProtectedMonkRoute = () => {
  const monkStatus = isMonk();

  if (!monkStatus) {
    return <Navigate to="/login" replace />;
  }

  return <MonkLayout />;
};

export default ProtectedMonkRoute;